export default __webpack_public_path__ + "static/media/AntyLucy_9.d4b9f223.jpg";